var React = require('react');

function FooterTopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#242526","fillOpacity":"1","d":"M0,32L120,48C240,64,480,96,720,101.3C960,107,1200,85,1320,74.7L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"}));
}

FooterTopInline.defaultProps = {"viewBox":"0 0 1440 150"};

module.exports = FooterTopInline;

FooterTopInline.default = FooterTopInline;
